import { render, staticRenderFns } from "./ListagemFollowupInteressado.vue?vue&type=template&id=cbca8d72"
import script from "./ListagemFollowupInteressado.vue?vue&type=script&lang=js"
export * from "./ListagemFollowupInteressado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports